<script setup>
import {computed} from "vue";
import {VIEWBOX_SIZE} from "@/components/seo-score/visibility-chart/composables/radialChart";

const props = defineProps({
  percentageChange: {
    type: Number,
    required: true,
  },
})

const percentagePill = computed(() => {
  const value = props.percentageChange * 100;

  const state = value > 0 ? 'success' : 'neutral';

  const palettes = {
    neutral: {
      textClass: 'tw-fill-neutral',
      fillClass: 'tw-fill-neutral-100',
      strokeClass: 'tw-stroke-neutral',
    },
    success: {
      textClass: 'tw-fill-success-700',
      fillClass: 'tw-fill-success-100',
      strokeClass: 'tw-stroke-success-700',
    },
  };

  const palette = palettes[state];
  const absoluteValue = Math.abs(value);

  // Display values betweem 0.1 and 9.9 with 1 decimal place. no decimals over 10% (rounded)
  const displayValue = absoluteValue < 9.95 ? absoluteValue.toFixed(1) : Math.round(absoluteValue);
  const display = `${displayValue}%`;

  const rotation = value < 0 ? 180 : value === 0 ? 90 : 0;

  return {
    state,
    display,
    rotation,
    ...palette,
  };
});

</script>

<template>
  <g :transform="`translate(${VIEWBOX_SIZE * 0.16}, ${VIEWBOX_SIZE * 0.20})`">
    <rect
      :x="-VIEWBOX_SIZE * 0.085"
      :y="-VIEWBOX_SIZE * 0.045"
      :width="VIEWBOX_SIZE * 0.17"
      :height="VIEWBOX_SIZE * 0.09"
      :rx="VIEWBOX_SIZE * 0.015"
      :class="[percentagePill.fillClass, percentagePill.strokeClass]"
      :stroke-width="VIEWBOX_SIZE * 0.003"
    />

    <g :transform="`translate(0, ${VIEWBOX_SIZE * 0.005})`">
      <path
        d="M0.2412 1.8699L0.2412 -1.2909L0.9324 -0.5997C1.026 -0.5061 1.1772 -0.5061 1.2708 -0.5997C1.3644 -0.6933 1.3644 -0.8445 1.2708 -0.9381L0.1692 -2.0397C0.0756 -2.1333 -0.0756 -2.1333 -0.1692 -2.0397L-1.2708 -0.9381C-1.3644 -0.8445 -1.3644 -0.6933 -1.2708 -0.5997C-1.1772 -0.5061 -1.026 -0.5061 -0.9324 -0.5997L-0.2388 -1.2909L-0.2388 1.8699C-0.2388 2.0019 -0.1308 2.1099 0.0012 2.1099C0.1332 2.1099 0.2412 2.0019 0.2412 1.8699Z"
        :class="percentagePill.textClass"
        :transform="`translate(${-VIEWBOX_SIZE * 0.04}, ${-VIEWBOX_SIZE * 0.003}) rotate(${percentagePill.rotation}) scale(0.65)`"
      />

      <text
        text-anchor="middle"
        dominant-baseline="middle"
        :font-size="VIEWBOX_SIZE * 0.035"
        :font-weight="VIEWBOX_SIZE * 5"
        :class="percentagePill.textClass"
      >
        <tspan :dx="VIEWBOX_SIZE * 0.02">
          {{ percentagePill.display }}
        </tspan>
      </text>
    </g>
  </g>
</template>
